import { useSignal } from "@preact/signals-react";

import { UserIcon, BookIcon, ChartBarIcon } from "components/Icons/linear";
import MainMenu from "componentsv2/widgets/MainMenu";
import Layout from "components/Layout/ViewLayout";

const styleIcon =
  "relative size-[60px] text-[#ffcc00FF] mx-auto my-3  group-hover:transition-all group-duration-300 ease-in-out group-hover:scale-110";

const view = [
  {
    name: "staff_request_name",
    desc: "staff_request_desc",
    link: "staff_supply/request",
    Icon: <UserIcon className={styleIcon} />,
    bg: "#FDFFD6",
  },
  {
    name: "staff_catalog_name",
    desc: "staff_catalog_desc",
    link: "staff_supply/staff_supply_product",
    Icon: <BookIcon className={styleIcon} />,
    bg: "#CFEEFF",
  },
  {
    name: "staff_indicators_name",
    desc: "staff_indicators_desc",
    Icon: <ChartBarIcon className={styleIcon} />,
    link: "staff_supply/staff_supply_indicators",
    bg: "#F7E2FE",
  },
];

function ScreenSupplies() {
  const currentView = useSignal(null);

  return (
    <Layout currentView={currentView} title="supply_name">
      <MainMenu views={view} desc="staff.title_main" />
    </Layout>
  );
}

export default ScreenSupplies;
